import { render, staticRenderFns } from "./ShipmentPanel.vue?vue&type=template&id=959b3396&"
import script from "./ShipmentPanel.vue?vue&type=script&lang=js&"
export * from "./ShipmentPanel.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentPanel.vue?vue&type=style&index=0&id=959b3396&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports